var _defs, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcelB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 415.47 324.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-26,.cls-6{fill:#fff;}.cls-1,.cls-11,.cls-2,.cls-21,.cls-23,.cls-24,.cls-25,.cls-26,.cls-3,.cls-8,.cls-9{stroke:#263238;}.cls-1,.cls-10,.cls-11,.cls-2,.cls-21,.cls-3,.cls-8,.cls-9{stroke-linecap:round;stroke-linejoin:round;}.cls-15,.cls-17,.cls-2,.cls-24{fill:#699dd1;}.cls-14,.cls-19,.cls-25,.cls-3{fill:#396caa;}.cls-13,.cls-4,.cls-5,.cls-9{fill:#d4ecff;}.cls-5{opacity:0.8;}.cls-20,.cls-7{opacity:0.15;}.cls-10,.cls-22,.cls-23,.cls-8{fill:#263238;}.cls-10{stroke:#fff;}.cls-11,.cls-21{fill:none;}.cls-12{clip-path:url(#clip-path);}.cls-13{opacity:0.6;}.cls-16{clip-path:url(#clip-path-2);}.cls-17,.cls-19{opacity:0.2;}.cls-18{clip-path:url(#clip-path-3);}.cls-21{stroke-width:0.25px;}.cls-23,.cls-24,.cls-25,.cls-26{stroke-miterlimit:10;stroke-width:0.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-35.72 -89.68)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.27,216.8a11.83,11.83,0,0,0-11.84,11.83V374a12,12,0,0,1-16,11.3L253.7,353.47a26.08,26.08,0,0,0-14.67-.82v-124a11.85,11.85,0,0,1,11.84-11.83Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-35.72 -89.68)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M347.46,386H227.06a12,12,0,0,1-4-.7L202.24,378l25.86-19.9a26.16,26.16,0,0,1,25.6-4.66l89.72,31.87A12,12,0,0,0,347.46,386Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-35.72 -89.68)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M379.63,220.27a11.76,11.76,0,0,0-8.36-3.47c-12.33,0-11.84,11.83-11.84,11.83v22.26h23.66V228.63A11.8,11.8,0,0,0,379.63,220.27Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    "data-name": "Background Simple"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M447.58,310.44S467.71,204,412.88,143.59c-48.4-53.31-125-74-187.49-30-22.25,15.71-38.45,46.2-64.45,55.63-29.15,10.57-66.63,14.35-93.7,59.64S49.89,332.33,86,363.29s99.25.75,156.16-1.51S417.73,441.8,447.58,310.44Z",
    transform: "translate(-35.72 -89.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M447.58,310.44S467.71,204,412.88,143.59c-48.4-53.31-125-74-187.49-30-22.25,15.71-38.45,46.2-64.45,55.63-29.15,10.57-66.63,14.35-93.7,59.64S49.89,332.33,86,363.29s99.25.75,156.16-1.51S417.73,441.8,447.58,310.44Z",
    transform: "translate(-35.72 -89.68)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Book_Shelf",
    "data-name": "Book Shelf"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M215.87,60h63.5a0,0,0,0,1,0,0V78.07a0,0,0,0,1,0,0h-63.5a5.13,5.13,0,0,1-5.13-5.13V65.13A5.13,5.13,0,0,1,215.87,60Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M315.09,127.11h-59.6a9,9,0,0,0-9,9h0a9,9,0,0,0,9,9h59.6Z",
    transform: "translate(-35.72 -89.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 284.79,
    y: 16.66,
    width: 21.67,
    height: 60.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 311.88,
    y: 16.66,
    width: 21.67,
    height: 60.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 338.97,
    y: 16.66,
    width: 21.67,
    height: 60.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "373.72 78.78 203.55 78.78 203.55 88.86 217.36 88.86 217.36 113.86 225.57 113.86 225.57 88.86 347.69 88.86 347.69 113.86 355.91 113.86 355.91 88.86 373.72 88.86 373.72 78.78"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M206.14,198.46a53.89,53.89,0,0,0-5.68,2.21c1-.75,2-1.52,3-2.3a146.67,146.67,0,0,0,12.88-11.65,137.7,137.7,0,0,1-15.25,12.79,30.83,30.83,0,0,0,1.95-4c1-2.52,1.2-5.05-1.21-6.41-3-1.66-6.56.82-5.6,5.1a15.52,15.52,0,0,0,3.26,6.43,96.16,96.16,0,0,1-10.94,6.55l-.36.19a35.14,35.14,0,0,0,2.12-4.3c1-2.52,1.19-5.06-1.22-6.41-3-1.67-6.55.82-5.6,5.09a15.6,15.6,0,0,0,3.21,6.37c-4.55,2.24-9.26,4.14-13.93,6.21l-.69.31a32,32,0,0,0,2.55-3.12c1.52-2.23,2.33-4.64.31-6.52-2.5-2.31-6.57-.72-6.64,3.65a15.67,15.67,0,0,0,1.65,7,71,71,0,0,0-12.4,7.36l-.13.09a26.84,26.84,0,0,0,1.44-2.57c1.14-2.44,1.57-4.95-.73-6.48a3.75,3.75,0,0,0-5.66,1.75,3.35,3.35,0,0,0-1.21-1.15c-2.32-1.35-4.6.11-6.55,2.16-.51.53-1,1.1-1.45,1.68a71.73,71.73,0,0,1,5.66-12.07,17.3,17.3,0,0,0,6.82,1.46c4.62,0,6.57-3.85,4.3-6.24-1.84-2-4.44-1.2-6.89.21-.81.47-1.6,1-2.35,1.54a70.08,70.08,0,0,1,8-9.9,17.45,17.45,0,0,0,6.58,3.31c4.49,1.11,7.31-2.15,5.69-5-1.32-2.34-4-2.24-6.74-1.46a34.18,34.18,0,0,0-3.77,1.39c1.23-1.19,2.5-2.34,3.78-3.47,1.69-1.44,3.43-2.83,5.2-4.18a17.32,17.32,0,0,0,6.47,3.23c4.49,1.11,7.31-2.15,5.69-5-1.32-2.33-4-2.23-6.74-1.46-.64.19-1.27.41-1.9.64,2.34-1.67,4.72-3.3,7.11-4.93l2.2-1.51a17.3,17.3,0,0,0,6.81,3.51c4.49,1.11,7.31-2.15,5.69-5-1.32-2.34-4-2.24-6.74-1.46a28.25,28.25,0,0,0-3.13,1.12h0l1.36-1c.83-.6,1.66-1.21,2.48-1.84,1-.76,2-1.61,2.95-2.41.57-.46,1.11-.93,1.64-1.42a17.37,17.37,0,0,0,6.86,3.54c4.48,1.11,7.3-2.15,5.68-5-1.32-2.33-4-2.24-6.74-1.46a36.69,36.69,0,0,0-4.42,1.67h0c1.84-1.7,3.61-3.47,5.29-5.33l.33-.38c.72-.8,1.44-1.61,2.12-2.44s1.58-2,2.33-3A57.61,57.61,0,0,0,212.38,141a57.51,57.51,0,0,1-7.79,13,81.93,81.93,0,0,1-10.4,11c-.14.13-.28.24-.42.36a38.74,38.74,0,0,0,2.31-4.65c1-2.52,1.2-5-1.21-6.41-3-1.66-6.56.82-5.61,5.1a15.69,15.69,0,0,0,3.56,6.77c-.3.26-.59.52-.9.77s-.7.59-1.06.87c-.59.47-1.19.94-1.8,1.39-.32.25-.64.5-1,.74-.87.63-1.74,1.26-2.62,1.87l-1.26.86-1.44,1A38,38,0,0,0,185,169.1c1-2.52,1.19-5-1.22-6.41-3-1.67-6.55.82-5.6,5.1a15.75,15.75,0,0,0,3.39,6.58l-1.06.7-4,2.58-.77.51c-.74.48-1.47,1-2.2,1.47l-1,.63c-1,.71-2.05,1.42-3.05,2.15a38.41,38.41,0,0,0,2.25-4.54c1-2.52,1.19-5.06-1.22-6.41-3-1.67-6.55.82-5.6,5.09a15.64,15.64,0,0,0,3.46,6.67c-1.72,1.27-3.41,2.57-5.07,3.92-1.2,1-2.39,2.05-3.56,3.12a25.48,25.48,0,0,0,1.36-2.89c1-2.52,1.19-5.05-1.22-6.41-3-1.67-6.55.82-5.6,5.1a15.62,15.62,0,0,0,3.21,6.36,71.8,71.8,0,0,0-8.83,10.68,27.9,27.9,0,0,0,.67-3.37c.32-2.67-.06-5.19-2.73-5.92-3.28-.9-6.16,2.38-4.2,6.3a15.59,15.59,0,0,0,4.7,5.44,74.79,74.79,0,0,0-6.37,13.14,25.16,25.16,0,0,0-.28-2.86c-.45-2.66-1.53-5-4.3-4.91-3.4.06-5.23,4-2.25,7.23a15.7,15.7,0,0,0,5.7,3.76,93.77,93.77,0,0,0-2.81,10.81c-.12.58-.21,1.16-.32,1.73l-.35.35c-.13-.5-.27-1-.43-1.49-.85-2.56-2.27-4.67-5-4.19-3.34.59-4.55,4.79-1.1,7.49a15.38,15.38,0,0,0,5.92,2.77l.12.29q-.56,4.13-.82,8.29c-.13,2.07-.2,4.15-.24,6.23-2.9,0-5,3.17-3,6.62a14.93,14.93,0,0,0,3.19,3.77c.24,3.9.63,7.8,1.14,11.67a3.2,3.2,0,0,0-3.09-.72c-1.83.5-2.65,2-2.95,3.77a3.68,3.68,0,0,0-1,2.5c-1.36-2-2.64-4.09-3.88-6.19a17.46,17.46,0,0,0,4.62-5.4c2.18-4.07-.28-7.61-3.46-6.75-2.58.71-3.16,3.35-3.08,6.18a30.42,30.42,0,0,0,.31,3.2l-1.33-2.36c-1.12-2-2.08-4.05-3.13-6.08-.26-.49-.49-1-.71-1.51a17.22,17.22,0,0,0,5.54-4.43c2.91-3.59,1.16-7.53-2.13-7.27-2.67.2-3.73,2.69-4.18,5.48a29.36,29.36,0,0,0-.32,3.68l-1-2.2a114.34,114.34,0,0,1-5-15.33,17.45,17.45,0,0,0,6.43-4c3.25-3.29,1.9-7.38-1.39-7.46-2.68-.06-4,2.31-4.71,5a36.65,36.65,0,0,0-.81,4.46c-.7-3-1.31-6-1.82-9.07-.35-1.89-.56-3.8-.81-5.71a17.16,17.16,0,0,0,7.16-3.21c3.65-2.84,2.85-7.07-.41-7.57-2.65-.41-4.25,1.77-5.32,4.39a44.84,44.84,0,0,0-1.59,5.09c-.2-2.22-.43-4.43-.53-6.65a101.91,101.91,0,0,1,0-13.76,102.22,102.22,0,0,0-.47,13.78c0,2.12.18,4.23.31,6.35a35.23,35.23,0,0,0-2-4.19c-1.39-2.32-3.23-4.07-5.79-3-3.14,1.29-3.42,5.65.53,7.56a15.76,15.76,0,0,0,7.41,1.41c.18,1.89.34,3.78.63,5.65.4,3,.9,6,1.49,8.91a29.05,29.05,0,0,0-2.15-3.26c-1.67-2.11-3.72-3.61-6.12-2.24-3,1.69-2.66,6,1.5,7.42a15.61,15.61,0,0,0,7.28.49,117.25,117.25,0,0,0,4.55,15.55l.6,1.52a22.22,22.22,0,0,0-1.73-2c-1.87-1.94-4.07-3.22-6.32-1.62-2.76,2-2,6.29,2.24,7.24a15.6,15.6,0,0,0,7.14-.21c.21.52.43,1,.68,1.54,1,2.09,1.91,4.23,3,6.28l.92,1.75c-.53-.45-1.08-.9-1.64-1.29-2.21-1.56-4.6-2.41-6.51-.41-2.35,2.46-.82,6.56,3.55,6.69a15.56,15.56,0,0,0,6.56-1.35c1.25,2.27,2.54,4.51,3.94,6.7.52.84,1.05,1.68,1.6,2.5a27,27,0,0,0-2.52-2.07c-2.2-1.55-4.6-2.4-6.51-.4-2.34,2.46-.82,6.55,3.56,6.69a15.72,15.72,0,0,0,7.21-1.66c.73,1,1.48,2,2.25,3-1.63,1.89-1.1,5.1,2.21,6.51a14.74,14.74,0,0,0,5.11,1.13c.21.17.41.33.63.48l.11.08c.76,2.88,1.6,5.74,2.48,8.58h-14.9v47.11h37.15V308.41H148.23c-1.49-5.09-2.74-9.52-3-9.64l-.53-.25a16.9,16.9,0,0,0,5.35-3c3.52-3,2.53-7.19-.75-7.55-2.66-.29-4.16,2-5.12,4.63-.27.75-.49,1.54-.69,2.32-.19-.71-.39-1.42-.57-2.13q-.8-3.17-1.49-6.33a17.37,17.37,0,0,0,5.79-3.19c3.52-3,2.52-7.18-.76-7.54-2.66-.29-4.16,2-5.12,4.62-.27.77-.5,1.57-.7,2.36-.31-1.54-.61-3.09-.88-4.64q-.28-1.73-.54-3.45c-.07-1.65-.1-3.29-.08-4.93,0-.91.05-1.81.09-2.72a16.85,16.85,0,0,0,6.15.79c4.61-.3,6.32-4.26,3.91-6.5-2-1.83-4.51-.92-6.87.64a34.68,34.68,0,0,0-3,2.34,73.64,73.64,0,0,1,1.75-11.45,60,60,0,0,1,1.94-6.55,17,17,0,0,0,6.59.93c4.62-.29,6.32-4.25,3.91-6.49-2-1.83-4.5-.92-6.86.64a29.67,29.67,0,0,0-2.43,1.83,49.53,49.53,0,0,1,3.1-6.07,44.82,44.82,0,0,1,8.74-10.48,17.24,17.24,0,0,0,6.14,3.64c4.39,1.44,7.44-1.6,6-4.58-1.14-2.42-3.84-2.53-6.61-2a30.19,30.19,0,0,0-3.11.86.18.18,0,0,1,.07-.05,68.75,68.75,0,0,1,12.13-7.62,17.38,17.38,0,0,0,5.66,4.79c4.1,2.12,7.6-.39,6.69-3.55-.74-2.58-3.39-3.11-6.21-3a29.65,29.65,0,0,0-3.31.37c4.56-2.16,9.23-4.2,13.72-6.58h0l.09,0a17.39,17.39,0,0,0,7,3.65c4.49,1.11,7.31-2.15,5.69-5-1.32-2.33-4-2.23-6.74-1.45a22.09,22.09,0,0,0-2.25.77q4.5-2.62,8.72-5.69l.23.25.06-.11a17.38,17.38,0,0,0,7,3.69c4.49,1.11,7.31-2.14,5.68-5C211.57,197.59,208.87,197.68,206.14,198.46ZM135.3,290.27c-.91-1.08-1.79-2.19-2.65-3.33.21-.18.43-.39.66-.61a15.57,15.57,0,0,0,3.9.7l0,.21.62-.12c.32,1.59.66,3.19,1,4.78A4.16,4.16,0,0,0,135.3,290.27Zm3.31-38.15c-.31,1.2-.58,2.39-.83,3.6l-.16-.21q0-3.7.12-7.39c.07-1.73.19-3.45.34-5.17a16.56,16.56,0,0,0,2.74,2.28A62.72,62.72,0,0,0,138.61,252.12Zm4.15-11.34c.06-.45.11-.91.13-1.35,0-.23,0-.46,0-.68.36-.11.73-.24,1.1-.39C143.58,239.15,143.16,240,142.76,240.78Zm5.28-8.57a3.23,3.23,0,0,0-1.86-1.74c-2.5-1-4.53.82-6.14,3.14l-.07.11-.16,0a5,5,0,0,0-.52-.07c0-.14,0-.28.07-.42A91.69,91.69,0,0,1,142,222.36a17.16,17.16,0,0,0,6.94-.53,6,6,0,0,0,3.4-2.36,15.75,15.75,0,0,0,2.5,5.69A46.43,46.43,0,0,0,148,232.21Z",
    transform: "translate(-35.72 -89.68)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M191.12,125.22H368.9a8,8,0,0,1,8,8V257.95a0,0,0,0,1,0,0H183.15a0,0,0,0,1,0,0V133.19A8,8,0,0,1,191.12,125.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "405.93 316.63 154.1 316.63 183.15 257.95 376.87 257.95 405.93 316.63"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 194.89,
    y: 135.73,
    width: 170.25,
    height: 111.71
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "271.93 276.52 272.27 269.37 262.03 269.37 261.35 276.52 271.93 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "293.08 276.52 292.74 269.37 282.5 269.37 282.51 276.52 293.08 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "348.18 284.17 359.12 284.17 356.55 276.52 345.97 276.52 348.18 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "261.35 276.52 262.03 269.37 251.79 269.37 250.77 276.52 261.35 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "240.2 276.52 241.56 269.37 231.32 269.37 229.62 276.52 240.2 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "335.4 276.52 333.68 269.37 323.44 269.37 324.82 276.52 335.4 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "345.97 276.52 343.91 269.37 333.68 269.37 335.4 276.52 345.97 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "229.62 276.52 231.32 269.37 221.09 269.37 219.04 276.52 229.62 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "303.66 276.52 302.97 269.37 292.74 269.37 293.08 276.52 303.66 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "356.55 276.52 354.15 269.37 343.91 269.37 345.97 276.52 356.55 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "324.82 276.52 323.44 269.37 313.21 269.37 314.24 276.52 324.82 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "314.24 276.52 313.21 269.37 302.97 269.37 303.66 276.52 314.24 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "282.51 276.52 282.5 269.37 272.27 269.37 271.93 276.52 282.51 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "208.46 276.52 197.89 276.52 194.97 284.17 205.91 284.17 208.46 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "210.85 269.37 200.62 269.37 197.89 276.52 208.46 276.52 210.85 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "219.04 276.52 221.09 269.37 210.85 269.37 208.46 276.52 219.04 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "191.84 292.36 188.47 301.16 200.23 301.16 203.17 292.36 191.84 292.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "205.91 284.17 194.97 284.17 191.84 292.36 203.17 292.36 205.91 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "203.17 292.36 200.23 301.16 211.99 301.16 214.51 292.36 203.17 292.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "250.77 276.52 251.79 269.37 241.56 269.37 240.2 276.52 250.77 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "249.68 284.17 250.77 276.52 240.2 276.52 238.74 284.17 249.68 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "238.74 284.17 240.2 276.52 229.62 276.52 227.8 284.17 238.74 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "260.63 284.17 261.35 276.52 250.77 276.52 249.68 284.17 260.63 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "219.04 276.52 208.46 276.52 205.91 284.17 216.85 284.17 219.04 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "350.54 292.36 361.87 292.36 359.12 284.17 348.18 284.17 350.54 292.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "227.8 284.17 229.62 276.52 219.04 276.52 216.85 284.17 227.8 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "205.91 284.17 203.17 292.36 214.51 292.36 216.85 284.17 205.91 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "326.29 284.17 324.82 276.52 314.24 276.52 315.35 284.17 326.29 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "315.35 284.17 314.24 276.52 303.66 276.52 304.4 284.17 315.35 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "348.18 284.17 345.97 276.52 335.4 276.52 337.23 284.17 348.18 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "282.51 284.17 282.51 276.52 271.93 276.52 271.57 284.17 282.51 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "304.4 284.17 303.66 276.52 293.08 276.52 293.46 284.17 304.4 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "293.46 284.17 293.08 276.52 282.51 276.52 282.51 284.17 293.46 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "271.57 284.17 271.93 276.52 261.35 276.52 260.63 284.17 271.57 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "304.4 284.17 305.19 292.36 316.53 292.36 315.35 284.17 304.4 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "315.35 284.17 316.53 292.36 327.87 292.36 326.29 284.17 315.35 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "216.85 284.17 214.51 292.36 225.84 292.36 227.8 284.17 216.85 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "326.29 284.17 327.87 292.36 339.2 292.36 337.23 284.17 326.29 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "282.51 284.17 282.52 292.36 293.86 292.36 293.46 284.17 282.51 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "337.23 284.17 339.2 292.36 350.54 292.36 348.18 284.17 337.23 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "293.46 284.17 293.86 292.36 305.19 292.36 304.4 284.17 293.46 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "238.74 284.17 237.18 292.36 248.51 292.36 249.68 284.17 238.74 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "227.8 284.17 225.84 292.36 237.18 292.36 238.74 284.17 227.8 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "271.57 284.17 271.19 292.36 282.52 292.36 282.51 284.17 271.57 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "260.63 284.17 259.85 292.36 271.19 292.36 271.57 284.17 260.63 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "249.68 284.17 248.51 292.36 259.85 292.36 260.63 284.17 249.68 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "337.23 284.17 335.4 276.52 324.82 276.52 326.29 284.17 337.23 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "210.85 269.37 213.3 262.06 203.41 262.06 200.62 269.37 210.85 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "200.62 269.37 191.17 269.37 188.12 276.52 197.89 276.52 200.62 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "203.41 262.06 194.29 262.06 191.17 269.37 200.62 269.37 203.41 262.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "197.89 276.52 188.12 276.52 184.86 284.17 194.97 284.17 197.89 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "194.97 284.17 184.86 284.17 181.37 292.36 191.84 292.36 194.97 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "191.84 292.36 181.37 292.36 177.62 301.16 188.47 301.16 191.84 292.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "367.13 276.52 370.06 284.17 379.75 284.17 376.49 276.52 367.13 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "373.21 292.36 383.24 292.36 379.75 284.17 370.06 284.17 373.21 292.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "376.59 301.16 386.99 301.16 383.24 292.36 373.21 292.36 376.59 301.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "292.74 269.37 292.38 262.06 282.49 262.06 282.5 269.37 292.74 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "367.13 276.52 376.49 276.52 373.44 269.37 364.38 269.37 367.13 276.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "361.87 292.36 373.21 292.36 370.06 284.17 359.12 284.17 361.87 292.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "221.09 269.37 223.18 262.06 213.3 262.06 210.85 269.37 221.09 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "354.15 269.37 356.55 276.52 367.13 276.52 364.38 269.37 354.15 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "373.44 269.37 370.32 262.06 361.58 262.06 364.38 269.37 373.44 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "364.38 269.37 361.58 262.06 351.69 262.06 354.15 269.37 364.38 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "327.87 292.36 329.56 301.16 341.32 301.16 339.2 292.36 327.87 292.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "364.83 301.16 376.59 301.16 373.21 292.36 361.87 292.36 364.83 301.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "354.15 269.37 351.69 262.06 341.81 262.06 343.91 269.37 354.15 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "350.54 292.36 353.07 301.16 364.83 301.16 361.87 292.36 350.54 292.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "339.2 292.36 341.32 301.16 353.07 301.16 350.54 292.36 339.2 292.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "359.12 284.17 370.06 284.17 367.13 276.52 356.55 276.52 359.12 284.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "262.03 269.37 262.72 262.06 252.84 262.06 251.79 269.37 262.03 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "343.91 269.37 341.81 262.06 331.92 262.06 333.68 269.37 343.91 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "251.79 269.37 252.84 262.06 242.95 262.06 241.56 269.37 251.79 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "282.5 269.37 282.49 262.06 272.61 262.06 272.27 269.37 282.5 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "241.56 269.37 242.95 262.06 233.07 262.06 231.32 269.37 241.56 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "231.32 269.37 233.07 262.06 223.18 262.06 221.09 269.37 231.32 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "272.27 269.37 272.61 262.06 262.72 262.06 262.03 269.37 272.27 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "333.68 269.37 331.92 262.06 322.04 262.06 323.44 269.37 333.68 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "323.44 269.37 322.04 262.06 312.15 262.06 313.21 269.37 323.44 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "302.97 269.37 302.26 262.06 292.38 262.06 292.74 269.37 302.97 269.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "327.87 292.36 316.53 292.36 305.19 292.36 293.86 292.36 282.52 292.36 271.19 292.36 259.85 292.36 248.51 292.36 237.18 292.36 225.84 292.36 214.51 292.36 211.99 301.16 223.74 301.16 235.5 301.16 247.26 301.16 259.02 301.16 270.77 301.16 282.53 301.16 294.29 301.16 306.05 301.16 317.8 301.16 329.56 301.16 327.87 292.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "313.21 269.37 312.15 262.06 302.26 262.06 302.97 269.37 313.21 269.37"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 154.1,
    y: 316.63,
    width: 251.94,
    height: 3.57
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Spreadsheets"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "347.37 161.21 347.37 257.3 319.44 293.71 314.75 295.47 171.47 316.61 171.47 321.31 118.98 324.13 118.98 272.57 208.46 272.57 208.46 160.75 347.37 161.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.53,351.94c-6.45.31-13.44,5.23-13.44,5.23L36.22,413.81H154.7s74.84-56.47,77.08-58.09c3.54-2.56,10.58-3.86,10.58-3.86l-3.33.08Z",
    transform: "translate(-35.72 -89.68)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 359.47,
    y1: 161.3,
    x2: 200.86,
    y2: 161.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M371.27,216.8a11.83,11.83,0,0,0-11.84,11.83V374a12,12,0,0,1-16,11.3L253.7,353.47a26.08,26.08,0,0,0-14.67-.82v-124a11.85,11.85,0,0,1,11.84-11.83Z",
    transform: "translate(-35.72 -89.68)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.72,357.39l78.7,27.95a12,12,0,0,0,16-11.3V357.39Z",
    transform: "translate(-35.72 -89.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M266.34,357.39,345,385.34a12,12,0,0,0,16-11.3V357.39Z",
    transform: "translate(-35.72 -89.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M264.72,376.54l78.7,28a12,12,0,0,0,16-11.3V376.54Z",
    transform: "translate(-35.72 -89.68)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M371.27,216.8a11.83,11.83,0,0,0-11.84,11.83V374a12,12,0,0,1-16,11.3L253.7,353.47a26.08,26.08,0,0,0-14.67-.82v-124a11.85,11.85,0,0,1,11.84-11.83Z",
    transform: "translate(-35.72 -89.68)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 208.42,
    y1: 262.26,
    x2: 203.31,
    y2: 262.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M347.46,386H227.06a12,12,0,0,1-4-.7L202.24,378l25.86-19.9a26.16,26.16,0,0,1,25.6-4.66l89.72,31.87A12,12,0,0,0,347.46,386Z",
    transform: "translate(-35.72 -89.68)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M347.46,386H227.06a12,12,0,0,1-4-.7L201,377.64l27.12-19.51a26.16,26.16,0,0,1,25.6-4.66l89.72,31.87A12,12,0,0,0,347.46,386Z",
    transform: "translate(-35.72 -89.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M347.46,386H227.06a12,12,0,0,1-4-.7L201,377.64l27.12-19.51a26.16,26.16,0,0,1,25.6-4.66l89.72,31.87A12,12,0,0,0,347.46,386Z",
    transform: "translate(-35.72 -89.68)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M347.46,386H227.06a12,12,0,0,1-4-.7L202.24,378l25.86-19.9a26.16,26.16,0,0,1,25.6-4.66l89.72,31.87A12,12,0,0,0,347.46,386Z",
    transform: "translate(-35.72 -89.68)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 191.34,
    y1: 296.37,
    x2: 191.08,
    y2: 296.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 311.97,
    y1: 296.37,
    x2: 311.74,
    y2: 296.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M379.63,220.27a11.76,11.76,0,0,0-8.36-3.47c-12.33,0-11.84,11.83-11.84,11.83v22.26h23.66V228.63A11.8,11.8,0,0,0,379.63,220.27Z",
    transform: "translate(-35.72 -89.68)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M379.63,220.27a11.76,11.76,0,0,0-8.36-3.47c-12.33,0-11.84,11.83-11.84,11.83v22.26h23.66V228.63A11.8,11.8,0,0,0,379.63,220.27Z",
    transform: "translate(-35.72 -89.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M379.63,220.27a11.76,11.76,0,0,0-8.36-3.47c-12.33,0-11.84,11.83-11.84,11.83v22.26h23.66V228.63A11.8,11.8,0,0,0,379.63,220.27Z",
    transform: "translate(-35.72 -89.68)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M379.63,220.27a11.76,11.76,0,0,0-8.36-3.47c-12.33,0-11.84,11.83-11.84,11.83v22.26h23.66V228.63A11.8,11.8,0,0,0,379.63,220.27Z",
    transform: "translate(-35.72 -89.68)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "214.37 147.5 214.37 147.71 214.37 152.76 214.37 152.97 214.37 158.02 214.37 158.23 214.37 163.27 214.37 163.48 214.37 168.53 214.37 168.74 214.37 173.79 214.37 174 214.37 179.04 214.37 179.25 214.37 184.3 214.37 184.51 214.37 189.56 214.37 189.77 214.37 194.81 214.37 195.02 214.37 200.07 214.37 200.28 214.37 205.54 225.8 205.54 225.8 200.28 225.8 200.07 225.8 195.02 225.8 194.81 225.8 189.77 225.8 189.56 225.8 184.51 225.8 184.3 225.8 179.25 225.8 179.04 225.8 174 225.8 173.79 225.8 168.74 225.8 168.53 225.8 163.48 225.8 163.27 225.8 158.23 225.8 158.02 225.8 152.97 225.8 152.76 225.8 147.71 225.8 147.5 225.8 142.25 214.37 142.25 214.37 147.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.49 142.25 304.24 142.25 293.31 142.25 293.06 142.25 282.12 142.25 281.87 142.25 270.94 142.25 270.69 142.25 259.75 142.25 259.5 142.25 248.56 142.25 248.32 142.25 237.38 142.25 237.13 142.25 225.94 142.25 225.94 147.71 237.13 147.71 237.38 147.71 248.32 147.71 248.56 147.71 259.5 147.71 259.75 147.71 270.69 147.71 270.94 147.71 281.87 147.71 282.12 147.71 293.06 147.71 293.31 147.71 304.24 147.71 304.49 147.71 315.68 147.71 315.68 142.25 304.49 142.25"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 214.37,
    y: 142.25,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 214.37,
    y: 147.5,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 214.37,
    y: 152.76,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 214.37,
    y: 158.02,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 214.37,
    y: 163.27,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 214.37,
    y: 168.53,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 214.37,
    y: 173.79,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 214.37,
    y: 179.04,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 214.37,
    y: 184.3,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 214.37,
    y: 189.56,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 214.37,
    y: 194.81,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 214.37,
    y: 200.07,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 225.94,
    y: 142.25,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 237.13,
    y: 142.25,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 248.32,
    y: 142.25,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 259.5,
    y: 142.25,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 270.69,
    y: 142.25,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 281.87,
    y: 142.25,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 293.06,
    y: 142.25,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 304.24,
    y: 142.25,
    width: 11.43,
    height: 5.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 225.8,
    y: 147.71,
    width: 89.87,
    height: 57.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 237.23,
    y1: 147.71,
    x2: 237.23,
    y2: 205.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 248.42,
    y1: 147.71,
    x2: 248.42,
    y2: 205.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 259.61,
    y1: 147.71,
    x2: 259.61,
    y2: 205.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 270.79,
    y1: 147.71,
    x2: 270.79,
    y2: 205.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 281.98,
    y1: 147.71,
    x2: 281.98,
    y2: 205.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 293.17,
    y1: 147.71,
    x2: 293.17,
    y2: 205.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 304.36,
    y1: 147.71,
    x2: 304.36,
    y2: 205.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 225.8,
    y1: 152.97,
    x2: 315.61,
    y2: 152.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 225.8,
    y1: 158.21,
    x2: 315.61,
    y2: 158.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 225.8,
    y1: 163.45,
    x2: 315.61,
    y2: 163.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 225.8,
    y1: 168.69,
    x2: 315.61,
    y2: 168.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 225.8,
    y1: 173.93,
    x2: 315.61,
    y2: 173.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 225.8,
    y1: 179.16,
    x2: 315.61,
    y2: 179.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 225.8,
    y1: 184.4,
    x2: 315.61,
    y2: 184.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 225.8,
    y1: 189.64,
    x2: 315.61,
    y2: 189.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 225.8,
    y1: 194.88,
    x2: 315.61,
    y2: 194.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 225.8,
    y1: 200.12,
    x2: 315.61,
    y2: 200.12
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "168.51 276.35 72.16 276.35 78.81 271.29 175.16 271.29 168.51 276.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "21.17 316.88 18.8 316.88 78.81 271.29 81.18 271.29 21.17 316.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "147.28 292.44 50.93 292.44 58.46 286.8 154.81 286.8 147.28 292.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "114.85 317.11 18.5 317.11 78.81 271.29 175.16 271.29 114.85 317.11"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 88.74,
    y1: 271.46,
    x2: 28.69,
    y2: 317.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 98.42,
    y1: 271.46,
    x2: 38.36,
    y2: 317.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 108.09,
    y1: 271.46,
    x2: 48.04,
    y2: 317.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 117.77,
    y1: 271.46,
    x2: 57.72,
    y2: 317.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 127.45,
    y1: 271.46,
    x2: 67.39,
    y2: 317.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 137.12,
    y1: 271.46,
    x2: 77.07,
    y2: 317.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 146.8,
    y1: 271.46,
    x2: 86.75,
    y2: 317.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 156.48,
    y1: 271.46,
    x2: 96.42,
    y2: 317.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 166.15,
    y1: 271.46,
    x2: 106.1,
    y2: 317.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 66.26,
    y1: 280.95,
    x2: 162.32,
    y2: 280.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 58.59,
    y1: 286.78,
    x2: 154.65,
    y2: 286.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 50.92,
    y1: 292.61,
    x2: 146.98,
    y2: 292.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 43.24,
    y1: 298.43,
    x2: 139.31,
    y2: 298.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 35.57,
    y1: 304.26,
    x2: 131.63,
    y2: 304.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 27.9,
    y1: 310.09,
    x2: 123.96,
    y2: 310.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 214.28,
    y: 209.95,
    width: 101.55,
    height: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 214.28,
    y: 209.95,
    width: 2.49,
    height: 48.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 214.28,
    y: 209.95,
    width: 101.55,
    height: 48.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 224.98,
    y1: 210.13,
    x2: 224.98,
    y2: 258.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 235.18,
    y1: 210.13,
    x2: 235.18,
    y2: 258.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 245.38,
    y1: 210.13,
    x2: 245.38,
    y2: 258.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 255.58,
    y1: 210.13,
    x2: 255.58,
    y2: 258.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 265.78,
    y1: 210.13,
    x2: 265.78,
    y2: 258.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 275.97,
    y1: 210.13,
    x2: 275.97,
    y2: 258.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 286.17,
    y1: 210.13,
    x2: 286.17,
    y2: 258.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 296.37,
    y1: 210.13,
    x2: 296.37,
    y2: 258.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 306.57,
    y1: 210.13,
    x2: 306.57,
    y2: 258.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 214.45,
    y1: 220.13,
    x2: 315.7,
    y2: 220.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 214.45,
    y1: 226.28,
    x2: 315.7,
    y2: 226.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 214.45,
    y1: 232.42,
    x2: 315.7,
    y2: 232.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 214.45,
    y1: 238.56,
    x2: 315.7,
    y2: 238.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 214.45,
    y1: 244.7,
    x2: 315.7,
    y2: 244.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 214.45,
    y1: 250.84,
    x2: 315.7,
    y2: 250.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 277.98,
    y: 240.77,
    width: 4.23,
    height: 9.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 284.76,
    y: 234.85,
    width: 4.23,
    height: 15.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 291.53,
    y: 224.97,
    width: 4.23,
    height: 25.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 298.3,
    y: 234.56,
    width: 4.23,
    height: 16.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 305.08,
    y: 224.97,
    width: 4.23,
    height: 25.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M274.38,328.46V340.2a11.74,11.74,0,1,1,0-23.48h0Z",
    transform: "translate(-35.72 -89.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M274.38,328.46l11.16-3.63A11.74,11.74,0,0,1,278,339.62a11.15,11.15,0,0,1-3.62.58Z",
    transform: "translate(-35.72 -89.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M274.38,328.46V316.72a11.54,11.54,0,0,1,11.16,8.11Z",
    transform: "translate(-35.72 -89.68)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelB);
export default __webpack_public_path__ + "static/media/excel-b.12ba3414ea0007809bb2a2f1b8381ee7.svg";
export { ForwardRef as ReactComponent };